import { handleException } from 'clients/exception-handling'
import { errorMessage, warnYogiQLFallback } from 'features/charts-v2/utils'

/**
 * A "View in charts" / "View in feedback" link's key: the target page's YogiQL
 * state, stored through that page's page-state route. A one-shot link has no
 * retry, so a failed or refused save falls back to the legacy key.
 */
export async function mintYogiQLLinkKey<S, K>(
  page: 'charts' | 'feedback',
  state: S,
  save: (state: S) => Promise<string>,
  legacy: () => Promise<K>,
): Promise<string | K> {
  try {
    return await save(state)
  } catch (error) {
    handleException(error, {
      operation: `conversation.link.${page}`,
      disposition: 'delegated',
      owner: 'conversation.link.legacy-fallback',
    })
    warnYogiQLFallback(
      `Ask Yogi ${page} link uses the legacy key: ${errorMessage(error)}`,
    )
    try {
      const key = await legacy()
      handleException(error, {
        operation: `conversation.link.${page}`,
        disposition: 'recovered',
        reason: 'Legacy page-state link created successfully.',
      })
      return key
    } catch (fallbackCause) {
      throw new AggregateError(
        [error, fallbackCause],
        'Both page-state link strategies failed.',
      )
    }
  }
}
